import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class FormApply extends Component {
    render() {
        return (
            <div className="wrap-form flat-text-center">
                <p className="free">Online Courses <Link to="#">for Free</Link></p>
                <div className="heading">
                    <h6 className="title"> START MY FREE MONTH </h6>
                    <p className="description">Stay Sharp. Get ahead with Learning Paths.</p>
                </div>
                <form>
                    <div className="wrap-input">
                        <input type="text" name="name" placeholder="Your name" />
                    </div>
                    <div className="wrap-input">
                        <input type="email" name="email" placeholder="Your email address" />
                    </div>
                    <div className="wrap-input last-child">
                        <input type="text" name="phone" placeholder="Your phone number" />
                    </div>
                    <div className="wrap-btn">
                        <button className="flat-button btn-apply">APPLY NOW</button>
                    </div>
                </form>
            </div>
        );
    }
}

export default FormApply;